<template>
    <div>
        <div class="row mb-1">
            <div
                v-if="hasLabel" 
                :class="labelClass">
                <label :for="controlId" class="dmv-text dmv-text-primary">
                    {{label}}
                </label>
            </div>
            <div :class="controlClass">
                <input
                    :id="controlId"
                    :name="controlId"
                    class="form-control text-control"
                    type="text"
                    :placeholder="placeholder"
                    :disabled="!isEnabled"
                    v-model="newValue"
                />
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import resourceMixin from '../../../../../Util/Mixins/resources';
import guidMixin from '../../../../../Util/Mixins/guid';

export default {
    name: 'info-text-input',
    mixins: [resourceMixin, guidMixin],
    created() {
        this.newValue = this.value;
    },
    data() {
        return {
            controlId: this.guid(),
            newValue: ''
        };
    },
    computed: {
        hasLabel() {
            return this.label != "";
        },
        labelClass() {
            return `col-${this.scale[0]}`; 
        },
        controlClass() {
            return this.hasLabel ? `col-${this.scale[1]}` : 'col-12'; 
        }
    },
    watch: {
        newValue(value) {
            this.$emit('input', value);
        }
    },
    props: {
        label: {
            type: String,
            default: ""
        },
        value: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        isEnabled: {
            type: Boolean,
            required: true
        },
        scale: {
            type: Array,
            default: () => [4,8]
        }
    }
}
</script>

<style scoped src="../../../Style/info-text-input.scss" lang="scss">

</style>
